import React, { useState, useCallback, useRef, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Button, TextField, Grid, Box, Typography } from "@mui/material";

import { StepIcon } from "../../../Kiosk/Components/ThankYou/StepIcon";

const IconSelector = ({ DefaultIcon, iconName, onChange }) => {
  const [logoPath, setLogoPath] = useState("");

  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadResult, setUploadResult] = useState(null);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 1,
        width: "100%",
        alignItems: "flex-start"
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: 209,
          flexGrow: 1
        }}
      >
        <StepIcon
          DefaultIcon={DefaultIcon}
          cssSizeString={"5em"}
          iconName={iconName}
        />
      </div>
      <div
        //class="thisDivIsNotConsistent"
        style={{
          display: "flex",
          flexDirection: "column",
          minWidth: 300,
          flexGrow: 2
        }}
      >
        <TextField
          id={"txtStep1Icon"}
          value={iconName}
          onChange={onChange}
          variant="outlined"
          fullWidth
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: "white"
            }
          }}
        />
        <a
          href="https://mui.com/material-ui/material-icons/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Material Icons
        </a>
        <br />
        Example: {DefaultIcon}
      </div>
    </Box>
  );
};

export default IconSelector;
